import { createStyles, rem } from '@mantine/core'
import { LeadgenWithBannerProps } from '..'

type StylesParams = {
  isModal?: boolean
  modalStyle: LeadgenWithBannerProps['modalStyle']
  bgColor?: string
}

export default createStyles(
  (theme, { isModal, modalStyle, bgColor }: StylesParams) => {
    return {
      root: {},
      wrapper: {
        ...(isModal &&
          modalStyle === 'fullscreen' && {
            maxHeight: '100%',
            overflowY: 'auto',
          }),
        [theme.fn.smallerThan('sm')]: {
          ...(isModal && {
            height: `calc(100% - 70px)`,
          }),
        },
      },
      container: {
        display: 'flex',
        gap: rem(16),
        alignItems: 'center',
        [theme.fn.smallerThan('sm')]: {
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: rem(16),
        },
        [theme.fn.largerThan('sm')]: {
          alignItems: 'center',
          justifyContent: 'space-evenly',
        },
      },
      bannerWrapper: {
        [theme.fn.smallerThan('sm')]: {
          margin: `0 ${rem(-16)}`,
        },
        [theme.fn.largerThan('sm')]: {
          display: 'flex',
          justifyContent: 'center',
        },
      },
      bannerFrame: {
        [theme.fn.largerThan('sm')]: {
          maxWidth: rem(552),
        },
      },
      bannerImg: {
        margin: 0,
        [theme.fn.smallerThan('sm')]: {
          '&.desktop': {
            display: 'none',
          },
        },
        [theme.fn.largerThan('sm')]: {
          maxHeight: 640,
          '&.mobile': {
            display: 'none',
          },
        },
      },
      formContainer: {},
      formWrapper: {
        // [theme.fn.largerThan('sm')]: {
        //   flex: '0 0 50%',
        // },
      },
      formFrame: {
        [theme.fn.largerThan('sm')]: {
          backgroundColor: '#fff',
          maxWidth: rem(460),
          width: '100%',
          borderRadius: rem(20),
          border: `1px solid ${
            bgColor ? 'transparent' : theme.colors.neutral[1]
          }`,
          paddingTop: 24,
          paddingLeft: 32,
          paddingBottom: 16,
          '&.has-scroll': {
            paddingRight: 6,
            paddingBottom: 32,
          },
        },
      },
      form: {},
      formHeading: {
        fontSize: 20,
        lineHeight: rem(26),
        [theme.fn.largerThan('sm')]: {
          fontSize: 22,
          lineHeight: rem(32),
        },
      },
      formControlList: {
        gap: 12,
        [theme.fn.largerThan('sm')]: {
          paddingTop: 0,
        },
      },
      formSubmitBtnWrapper: {
        paddingTop: 8,
      },
      formRoot: {},
      modal: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      skipBtn: {
        backgroundColor: 'transparent',
        color: theme.colors.gray[8],
        [theme.fn.largerThan('sm')]: {
          color: '#8C8C8C',
        },
      },
      closeBtn: {
        position: 'absolute',
        borderColor: 'transparent',
        top: 0,
        right: 0,
      },
      closeWithIconBtn: {
        top: '10px !important' as any,
        right: '10px !important' as any,
        width: 32,
        height: 32,
        borderRadius: '50%',
        backgroundColor: '#fff',
        '&:hover': {
          backgroundColor: theme.colors.neutral[0],
        },
      },
      scrollAreaThumb: {
        backgroundColor: '#D9D9D9',
      },
      scrollAreaViewport: {
        [theme.fn.largerThan('sm')]: {
          paddingRight: rem(29),
          paddingBottom: 0,
        },
      },
      scrollAreaScrollbar: {
        [theme.fn.largerThan('sm')]: {
          '&[data-orientation="vertical"]': {
            bottom: '50px !important',
          },
        },
        '&[data-orientation="horizontal"]': {
          display: 'none',
        },
      },
    }
  },
)
